/**
 * Not Found Page (404)
 *
 * Shown when the requested route doesn't exist.
 */

import React from "react";
import { ROUTES } from "@/router/routes";
import { AccessError } from "@/components/shared/AccessError";

export const NotFoundPage: React.FC = () => {
  return (
    <AccessError
      code="404"
      message="Siden finnes ikke."
      homeUrl={ROUTES.BOOKING}
      homeLinkText="Gå til booking"
      data-testid="not-found-page"
    />
  );
};

export default NotFoundPage;
